import { sumCredits } from "../available-credit";
export function make() {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const credits = data.credits || [];
  return {
    credits,
    totalCredits: sumCredits(credits),
    manualServices: data.manualServices || {}
  };
}